import React, { useEffect, useState } from 'react'
import { DragDropContext, Draggable, Droppable } from 'react-beautiful-dnd'
import { useNavigate } from 'react-router'
import { toast } from 'react-toastify'
import { auth } from '../../../firebase'
import cloudFunctions from '../../../Helpers/cloudFunctions'

export default function Rank({ poll, pollID, fetchAndSetPollData, showResults, cta, privatePoll }) {
    const [options, setOptions] = useState(null)
    useEffect(() => {
        if (showResults && options && !options?.sorted) {
            const sorted = new Array()
            const newPollResults = []
            for (let i = 0; i < poll.options.length; i++) {
                sorted.push({
                    rank: i + 1,
                    score: 0
                })
                if (i + 1 === poll.options.length) {
                    for (let x = 0; x < sorted.length; x++) {
                        optionLoop: for (let q = 0; q < poll.options.length; q++) {
                            if (poll.options[q].votes[x + 1] > sorted[x].score) {
                                for (let o = 0; o < sorted.length; o++) {
                                    if (sorted[o].contentID === poll.options[q].option) {
                                        continue optionLoop
                                    } else if (o + 1 === sorted.length) {
                                        sorted[x].score = poll.options[q].votes[x + 1]
                                        sorted[x].contentID = poll.options[q].option

                                    }
                                }
                            }
                        }
                        if (x + 1 === sorted.length) {
                            parentLoop: for (let u = 0; u < sorted.length; u++) {
                                subLoop: for (let y = 0; y < poll.options.length; y++) {
                                    if (poll.options[y].option === sorted[u].contentID) {
                                        newPollResults.push(poll.options[y])
                                        if (u + 1 === sorted.length) {
                                            const data = {
                                                options: new Object(),
                                                columns: new Object(),
                                                sorted: true
                                            }
                                            for (let i = 0; i < newPollResults.length; i++) {
                                                data.options[`option-${i}`] = {
                                                    id: `option-${i}`,
                                                    content: newPollResults[i].option
                                                }
                                                if (i + 1 === newPollResults.length) {
                                                    data.columns["column-1"] = {
                                                        id: "column-1",
                                                        title: "Results",
                                                        optionIds: new Array()
                                                    }
                                                    const tempIDs = new Array()
                                                    for (let x = 0; x < newPollResults.length; x++) {
                                                        tempIDs.push(`option-${x}`)
                                                        if (x + 1 === newPollResults.length) {
                                                            data.columns["column-1"].optionIds = tempIDs
                                                            data.columnOrder = ["column-1"]
                                                            setOptions(data)
                                                        }
                                                    }
                                                }
                                            }



                                            break subLoop
                                        } else {
                                            continue parentLoop
                                        }
                                    } else {
                                        continue subLoop
                                    }
                                }
                            }
                        }
                    }
                }
            }
        }
    }, [showResults, options])
    const navigate = useNavigate()
    useEffect(() => {
        const data = {
            options: new Object(),
            columns: new Object()
        }
        for (let i = 0; i < poll.options.length; i++) {
            data.options[`option-${i}`] = {
                id: `option-${i}`,
                content: poll.options[i].option
            }
            if (i + 1 === poll.options.length) {
                data.columns["column-1"] = {
                    id: "column-1",
                    title: "Your Ranking",
                    optionIds: new Array()
                }
                const tempIDs = new Array()
                for (let x = 0; x < poll.options.length; x++) {
                    tempIDs.push(`option-${x}`)
                    if (x + 1 === poll.options.length) {
                        data.columns["column-1"].optionIds = tempIDs
                        data.columnOrder = ["column-1"]
                        setOptions(data)
                    }
                }
            }
        }
    }, [])
    const Option = (props) => {
        const [rank, setRank] = useState(null)
        useEffect(() => {
            const content = props.option.content
            for (let i = 0; i < poll.options.length; i++) {

                if (poll.options[i].option === content) {
                    let topScore = {
                        rank: 0,
                        score: 0
                    }
                    for (const x in poll.options[i].votes) {
                        if (poll.options[i].votes[x] > topScore.score) {
                            topScore = {
                                rank: x,
                                score: poll.options[i].votes[x]
                            }
                        }
                        if (x === Object.keys(poll.options[i].votes)[Object.keys(poll.options[i].votes).length - 1]) {
                            setRank(topScore)
                        }
                    }
                }
            }
        }, [])
        return (
            <Draggable draggableId={props.option.id} index={props.index}>
                {(provided, snapshot) => (
                    <div {...provided.draggableProps} ref={provided.innerRef} className={`pollOptionRank flex aic jcsb ${snapshot.isDragging ? "pollOptionRankIsDragging" : ""}`}>
                        <div className='flex aic jcsb' style={{ width: "100%" }}>
                            <div className='flex aic' style={{ gap: 5 }}>
                                {!showResults
                                    ? <div className='flex aic' {...provided.dragHandleProps}>
                                        <svg style={{ opacity: .5 }} xmlns="http://www.w3.org/2000/svg" height="24px" viewBox="0 0 24 24" width="24px" fill="#000"><path d="M0 0h24v24H0V0z" fill="none" /><path d="M11 18c0 1.1-.9 2-2 2s-2-.9-2-2 .9-2 2-2 2 .9 2 2zm-2-8c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2zm0-6c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2zm6 4c1.1 0 2-.9 2-2s-.9-2-2-2-2 .9-2 2 .9 2 2 2zm0 2c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2zm0 6c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2z" /></svg>
                                    </div>
                                    : null
                                }
                                <p>
                                    {props.option.content}
                                </p>
                            </div>
                            {showResults && rank
                                ? <div className='flex aic'>
                                    <p style={{ opacity: .6, marginRight: 20 }}>{rank.score} votes</p>
                                    <div style={{ width: 35, height: 35, borderRadius: "50%", background: rank.rank == 1 ? "#FFD700" : (rank.rank == 2 ? "#ccc" : (rank.rank == 3 ? "#CD7F32" : "rgba(0,0,0,.1)")), fontWeight: "bold" }} className="flex aic jcc">
                                        <p>{rank.rank}</p>
                                    </div>
                                </div>
                                : null
                            }
                        </div>
                    </div>
                )
                }
            </Draggable >
        )
    }
    const Column = (props) => {
        return (
            <div style={{ background: "white", boxShadow: "0px 0px 10px rgba(0,0,0,.1)", padding: "40px 30px", borderRadius: 20 }}>
                <h2 style={{ margin: 0, marginBottom: 30, fontWeight: "bold" }}>{props.column.title}</h2>
                <div style={{ boxShadow: "0px 0px 10px rgba(0,0,0,.1)", backgroundColor: "white", padding: 20, borderRadius: 20, position: "relative" }} className="rankedPollPad">
                    <Droppable droppableId={props.column.id}>
                        {provided => (
                            <div
                                ref={provided.innerRef}
                                {...provided.droppableProps}
                                className="flex fdc"
                            >
                                {props.options.map((option, idx) => <Option last={idx === props.options.length - 1} key={option.id} option={option} index={idx} />)}
                                {provided.placeholder}
                            </div>
                        )}
                    </Droppable>
                    {!showResults
                        ? <p className='flex aic' style={{ fontSize: 12, margin: 0, paddingBottom: 10, marginLeft: 5 }}>
                            Use the
                            <svg style={{ opacity: .5 }} xmlns="http://www.w3.org/2000/svg" height="18px" viewBox="0 0 24 24" width="18px" fill="#000000"><path d="M0 0h24v24H0V0z" fill="none" /><path d="M11 18c0 1.1-.9 2-2 2s-2-.9-2-2 .9-2 2-2 2 .9 2 2zm-2-8c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2zm0-6c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2zm6 4c1.1 0 2-.9 2-2s-.9-2-2-2-2 .9-2 2 .9 2 2 2zm0 2c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2zm0 6c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2z" /></svg>
                            syombol to drag
                        </p>
                        : null
                    }
                </div>
                <button className={`b5 flex aic jcc ${showResults || !auth.currentUser ? "disabled" : ""}`} style={{ gap: 10, marginTop: 30 }} onClick={() => {
                    if (!auth.currentUser) {
                        return navigate("/login")
                    }
                    const loader = toast.loading("Submitting your vote")
                    const orderedOptions = new Array()
                    for (let i = 0; i < options.columns["column-1"].optionIds.length; i++) {
                        orderedOptions.push(options.options[options.columns["column-1"].optionIds[i]].content)
                        if (i + 1 === options.columns["column-1"].optionIds.length) {
                            return cloudFunctions.vote({
                                pollID: pollID,
                                option: orderedOptions,
                                private: privatePoll
                            }).then((res) => {
                                if (res.error) {
                                    toast.update(loader, {
                                        render: res.msg,
                                        icon: "❌"
                                    })
                                } else {
                                    toast.update(loader, {
                                        render: "Vote submitted!",
                                        icon: "✔️"
                                    })
                                    if (cta) window.open(cta)
                                    fetchAndSetPollData()
                                }
                            }).catch((err) => {
                                toast.update(loader, {
                                    render: "Something went wrong!",
                                    icon: "❌"
                                })
                            }).finally(() => {
                                setTimeout(() => {
                                    toast.dismiss(loader)
                                }, 2000)
                            })
                        }
                    }

                }}>
                    <svg width="27" height="27" viewBox="0 0 27 27" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M24.75 11.25V6.75C24.75 5.50125 23.7375 4.5 22.5 4.5H4.5C3.2625 4.5 2.26125 5.50125 2.26125 6.75V11.25C3.49875 11.25 4.5 12.2625 4.5 13.5C4.5 14.7375 3.49875 15.75 2.25 15.75V20.25C2.25 21.4875 3.2625 22.5 4.5 22.5H22.5C23.7375 22.5 24.75 21.4875 24.75 20.25V15.75C23.5125 15.75 22.5 14.7375 22.5 13.5C22.5 12.2625 23.5125 11.25 24.75 11.25ZM22.5 9.6075C21.1612 10.3837 20.25 11.8462 20.25 13.5C20.25 15.1538 21.1612 16.6163 22.5 17.3925V20.25H4.5V17.3925C5.83875 16.6163 6.75 15.1538 6.75 13.5C6.75 11.835 5.85 10.3837 4.51125 9.6075L4.5 6.75H22.5V9.6075ZM12.375 16.875H14.625V19.125H12.375V16.875ZM12.375 12.375H14.625V14.625H12.375V12.375ZM12.375 7.875H14.625V10.125H12.375V7.875Z" fill="white" />
                    </svg>
                    Vote
                </button>
            </div>
        )
    }
    if (options) {
        const onDragEnd = result => {
            const { destination, source, draggableId } = result
            if (!destination) {
                return
            }
            if (destination.droppableId === source.droppableId && destination.index === source.index) {
                return
            }

            const column = options.columns[source.droppableId]
            const newTaskIds = Array.from(column.optionIds)
            newTaskIds.splice(source.index, 1)
            newTaskIds.splice(destination.index, 0, draggableId)

            const newColumn = {
                ...column,
                optionIds: newTaskIds
            }

            setOptions({
                ...options,
                columns: {
                    ...options.columns,
                    [newColumn.id]: newColumn
                }
            })
        }
        return (
            <DragDropContext
                onDragEnd={onDragEnd}
            >
                {options.columnOrder.map((columnId) => {
                    const column = options.columns[columnId]
                    const tasks = column.optionIds.map(optionID => options.options[optionID])

                    return <Column key={column.id} column={column} options={tasks} />
                })}
            </DragDropContext>
        )
    } else {
        return null
    }
}
